export default __webpack_public_path__ + "static/media/SWT0020.34I-21280_-20729_0.6b7d6adf.jpg";